import React from 'react';
import ReactDOM from 'react-dom';

import { Dialog } from '@mui/material';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide, { SlideProps } from '@mui/material/Slide';

import { UxContext } from './UxContext';

const AlertTransition = React.forwardRef<HTMLElement, SlideProps>(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const AlertBox = () => {
    const { isShowAlert, handleAlert, alertData } = React.useContext(UxContext)!;

    function onClose() {
        handleAlert();
    }

    function onCancel() {
        onClose();
        if (alertData.cancelCallback) {
            alertData.cancelCallback();
        }
    }

    function onClick() {
        onClose();
        if (alertData.okCallback) {
            alertData.okCallback();
        }
    }

    if (isShowAlert) {
        return ReactDOM.createPortal(
            <Dialog open={isShowAlert} TransitionComponent={AlertTransition} keepMounted onClose={onClose}>
                <DialogTitle>{alertData.title}</DialogTitle>
                <DialogContent>
                    <DialogContentText component="div">{alertData.message}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    {alertData.cancelText ? <Button onClick={onCancel}>{alertData.cancelText}</Button> : null}
                    <Button onClick={onClick} variant="contained" color={alertData.destructive ? 'error' : 'primary'}>
                        {alertData.okText}
                    </Button>
                </DialogActions>
            </Dialog>,
            document.querySelector('#alert') as Element
        );
    }

    return null;
};

export default AlertBox;
